module.exports = __webpack_public_path__ + "static/media/Gemmer, Kelli 2023_1701944702852.bc4f4e8a.jpg";